import { MinutesStep } from '../constants'

/* Returns false for 15-minute intervals (:00, :15, :30, :45) OR 23:59. */
export const isManualTariffMinuteDisabled = (minute: number, hour: number | undefined): boolean =>
  minute % MinutesStep !== 0 && !(hour === 23 && minute === 59)
